// Indian States and Cities data
export const indianStatesAndCities = {
  "andhra-pradesh": [
    { value: "visakhapatnam", label: "Visakhapatnam" },
    { value: "vijayawada", label: "Vijayawada" },
    { value: "guntur", label: "Guntur" },
    { value: "nellore", label: "Nellore" },
    { value: "kurnool", label: "Kurnool" },
    { value: "rajahmundry", label: "Rajahmundry" },
    { value: "tirupati", label: "Tirupati" },
    { value: "kakinada", label: "Kakinada" },
    { value: "anantapur", label: "Anantapur" },
    { value: "kadapa", label: "Kadapa" },
    { value: "chittoor", label: "Chittoor" },
    { value: "eluru", label: "Eluru" },
    { value: "ongole", label: "Ongole" },
    { value: "vizianagaram", label: "Vizianagaram" },
    { value: "machilipatnam", label: "Machilipatnam" },
    { value: "sri-city", label: "Sri City" },
    { value: "amalapuram", label: "Amalapuram" },
    { value: "tenali", label: "Tenali" },
    { value: "narasaraopet", label: "Narasaraopet" },
    { value: "hindupur", label: "Hindupur" }
  ],
  "arunachal-pradesh": [
    { value: "itanagar", label: "Itanagar" },
    { value: "naharlagun", label: "Naharlagun" },
    { value: "pasighat", label: "Pasighat" },
    { value: "namsai", label: "Namsai" },
    { value: "tawang", label: "Tawang" },
    { value: "ziro", label: "Ziro" },
    { value: "along", label: "Along (Aalo)" },
    { value: "bomdila", label: "Bomdila" },
    { value: "roing", label: "Roing" },
    { value: "tezu", label: "Tezu" },
    { value: "daporijo", label: "Daporijo" },
    { value: "changlang", label: "Changlang" },
    { value: "khonsa", label: "Khonsa" },
    { value: "seppa", label: "Seppa" },
    { value: "yingkiong", label: "Yingkiong" }
  ],
  "assam": [
    { value: "guwahati", label: "Guwahati" },
    { value: "silchar", label: "Silchar" },
    { value: "dibrugarh", label: "Dibrugarh" },
    { value: "jorhat", label: "Jorhat" },
    { value: "tezpur", label: "Tezpur" },
    { value: "nagaon", label: "Nagaon" },
    { value: "tinsukia", label: "Tinsukia" },
    { value: "sivasagar", label: "Sivasagar" },
    { value: "dhubri", label: "Dhubri" },
    { value: "goalpara", label: "Goalpara" },
    { value: "barpeta", label: "Barpeta" },
    { value: "diphu", label: "Diphu" },
    { value: "karimganj", label: "Karimganj" },
    { value: "bongaigaon", label: "Bongaigaon" },
    { value: "kokrajhar", label: "Kokrajhar" },
    { value: "lakhimpur", label: "Lakhimpur" },
    { value: "haflong", label: "Haflong" }
  ],
  "bihar": [
    { value: "patna", label: "Patna" },
    { value: "gaya", label: "Gaya" },
    { value: "bhagalpur", label: "Bhagalpur" },
    { value: "muzaffarpur", label: "Muzaffarpur" },
    { value: "darbhanga", label: "Darbhanga" },
    { value: "purnia", label: "Purnia" },
    { value: "arrah", label: "Arrah" },
    { value: "begusarai", label: "Begusarai" },
    { value: "katihar", label: "Katihar" },
    { value: "chapra", label: "Chapra" },
    { value: "sasaram", label: "Sasaram" },
    { value: "hajipur", label: "Hajipur" },
    { value: "siwan", label: "Siwan" },
    { value: "motihari", label: "Motihari" },
    { value: "samastipur", label: "Samastipur" },
    { value: "madhubani", label: "Madhubani" },
    { value: "nawada", label: "Nawada" },
    { value: "jamui", label: "Jamui" }
  ],
  "chhattisgarh": [
    { value: "raipur", label: "Raipur" },
    { value: "bilaspur", label: "Bilaspur" },
    { value: "durg", label: "Durg" },
    { value: "bhilai", label: "Bhilai" },
    { value: "korba", label: "Korba" },
    { value: "rajnandgaon", label: "Rajnandgaon" },
    { value: "jagdalpur", label: "Jagdalpur" },
    { value: "ambikapur", label: "Ambikapur" },
    { value: "raigarh", label: "Raigarh" },
    { value: "dhamtari", label: "Dhamtari" },
    { value: "kanker", label: "Kanker" },
    { value: "janjgir", label: "Janjgir" },
    { value: "mahasamund", label: "Mahasamund" },
    { value: "balod", label: "Balod" }
  ],
  "delhi": [
    { value: "new-delhi", label: "New Delhi" },
    { value: "central-delhi", label: "Central Delhi" },
    { value: "north-delhi", label: "North Delhi" },
    { value: "south-delhi", label: "South Delhi" },
    { value: "east-delhi", label: "East Delhi" },
    { value: "west-delhi", label: "West Delhi" },
    { value: "north-east-delhi", label: "North East Delhi" },
    { value: "north-west-delhi", label: "North West Delhi" },
    { value: "south-east-delhi", label: "South East Delhi" },
    { value: "south-west-delhi", label: "South West Delhi" },
    { value: "shahdara", label: "Shahdara" }
  ],
  "gujarat": [
    { value: "ahmedabad", label: "Ahmedabad" },
    { value: "surat", label: "Surat" },
    { value: "vadodara", label: "Vadodara" },
    { value: "rajkot", label: "Rajkot" },
    { value: "gandhinagar", label: "Gandhinagar" },
    { value: "bhavnagar", label: "Bhavnagar" },
    { value: "jamnagar", label: "Jamnagar" },
    { value: "junagadh", label: "Junagadh" },
    { value: "porbandar", label: "Porbandar" },
    { value: "morbi", label: "Morbi" },
    { value: "anand", label: "Anand" },
    { value: "nadiad", label: "Nadiad" },
    { value: "bharuch", label: "Bharuch" },
    { value: "valsad", label: "Valsad" },
    { value: "vapi", label: "Vapi" },
    { value: "mehsana", label: "Mehsana" },
    { value: "patan", label: "Patan" },
    { value: "surendranagar", label: "Surendranagar" },
    { value: "botad", label: "Botad" },
    { value: "amreli", label: "Amreli" },
    { value: "godhra", label: "Godhra" },
    { value: "dahod", label: "Dahod" },
    { value: "palanpur", label: "Palanpur" },
    { value: "deesa", label: "Deesa" },
    { value: "himmatnagar", label: "Himmatnagar" },
    { value: "navsari", label: "Navsari" },
    { value: "veraval", label: "Veraval" },
    { value: "kalol", label: "Kalol" },
    { value: "gondal", label: "Gondal" },
    { value: "mandvi", label: "Mandvi" },
    { value: "bhuj", label: "Bhuj" },
    { value: "anjar", label: "Anjar" },
    { value: "kandla", label: "Kandla" }
  ],

  "haryana": [
    { value: "chandigarh", label: "Chandigarh" },
    { value: "gurgaon", label: "Gurgaon" },
    { value: "faridabad", label: "Faridabad" },
    { value: "panipat", label: "Panipat" },
    { value: "sonipat", label: "Sonipat" },
    { value: "rohtak", label: "Rohtak" },
    { value: "hisar", label: "Hisar" },
    { value: "karnal", label: "Karnal" },
    { value: "ambala", label: "Ambala" },
    { value: "yamunanagar", label: "Yamunanagar" },
    { value: "panchkula", label: "Panchkula" },
    { value: "kurukshetra", label: "Kurukshetra" },
    { value: "rewari", label: "Rewari" },
    { value: "bhiwani", label: "Bhiwani" },
    { value: "jhajjar", label: "Jhajjar" },
    { value: "palwal", label: "Palwal" },
    { value: "nuh", label: "Nuh" },
    { value: "sirsa", label: "Sirsa" }
  ],
  "himachal-pradesh": [
    { value: "shimla", label: "Shimla" },
    { value: "dharamshala", label: "Dharamshala" },
    { value: "manali", label: "Manali" },
    { value: "solan", label: "Solan" },
    { value: "mandi", label: "Mandi" },
    { value: "una", label: "Una" },
    { value: "bilaspur-hp", label: "Bilaspur" },
    { value: "hamirpur", label: "Hamirpur" },
    { value: "palampur", label: "Palampur" },
    { value: "kullu", label: "Kullu" },
    { value: "chamba", label: "Chamba" },
    { value: "nahan", label: "Nahan" },
    { value: "kangra", label: "Kangra" }
  ],
  "jammu-kashmir": [
    { value: "srinagar", label: "Srinagar" },
    { value: "jammu", label: "Jammu" },
    { value: "anantnag", label: "Anantnag" },
    { value: "baramulla", label: "Baramulla" },
    { value: "pulwama", label: "Pulwama" },
    { value: "kupwara", label: "Kupwara" },
    { value: "budgam", label: "Budgam" },
    { value: "udhampur", label: "Udhampur" },
    { value: "kathua", label: "Kathua" },
    { value: "rajouri", label: "Rajouri" }
  ],
  "ladakh": [
    { value: "leh", label: "Leh" },
    { value: "kargil", label: "Kargil" }
  ],
  "jharkhand": [
    { value: "ranchi", label: "Ranchi" },
    { value: "jamshedpur", label: "Jamshedpur" },
    { value: "dhanbad", label: "Dhanbad" },
    { value: "bokaro", label: "Bokaro" },
    { value: "deoghar", label: "Deoghar" },
    { value: "hazaribagh", label: "Hazaribagh" },
    { value: "giridih", label: "Giridih" },
    { value: "ramgarh", label: "Ramgarh" },
    { value: "phusro", label: "Phusro" },
    { value: "dumka", label: "Dumka" },
    { value: "chaibasa", label: "Chaibasa" },
    { value: "medininagar", label: "Medininagar (Daltonganj)" }
  ],
  "karnataka": [
    { value: "bengaluru", label: "Bengaluru" }, // Bangalore
    { value: "mysuru", label: "Mysuru" },       // Mysore
    { value: "hubballi", label: "Hubballi" },   // Hubli
    { value: "mangaluru", label: "Mangaluru" }, // Mangalore
    { value: "belagavi", label: "Belagavi" },
    { value: "davanagere", label: "Davanagere" },
    { value: "ballari", label: "Ballari" },
    { value: "kalaburagi", label: "Kalaburagi" },
    { value: "shivamogga", label: "Shivamogga" },
    { value: "tumakuru", label: "Tumakuru" },
    { value: "udupi", label: "Udupi" },
    { value: "hassan", label: "Hassan" },
    { value: "chitradurga", label: "Chitradurga" }
  ],

  "kerala": [
    { value: "kochi", label: "Kochi" },
    { value: "thiruvananthapuram", label: "Thiruvananthapuram" }, // Trivandrum
    { value: "kozhikode", label: "Kozhikode" },
    { value: "thrissur", label: "Thrissur" },
    { value: "kollam", label: "Kollam" },
    { value: "alappuzha", label: "Alappuzha" },
    { value: "kottayam", label: "Kottayam" },
    { value: "palakkad", label: "Palakkad" },
    { value: "malappuram", label: "Malappuram" },
    { value: "kannur", label: "Kannur" },
    { value: "kasaragod", label: "Kasaragod" },
    { value: "wayanad", label: "Wayanad" },
    { value: "pathanamthitta", label: "Pathanamthitta" }
  ],

  "madhya-pradesh": [
    { value: "bhopal", label: "Bhopal" },
    { value: "indore", label: "Indore" },
    { value: "gwalior", label: "Gwalior" },
    { value: "jabalpur", label: "Jabalpur" },
    { value: "ujjain", label: "Ujjain" },
    { value: "sagar", label: "Sagar" },
    { value: "ratlam", label: "Ratlam" },
    { value: "satna", label: "Satna" },
    { value: "rewa", label: "Rewa" },
    { value: "dewas", label: "Dewas" },
    { value: "khandwa", label: "Khandwa" },
    { value: "chhindwara", label: "Chhindwara" },
    { value: "morena", label: "Morena" }
  ],

  "maharashtra": [
    { value: "mumbai", label: "Mumbai" },
    { value: "pune", label: "Pune" },
    { value: "nagpur", label: "Nagpur" },
    { value: "chhatrapati-sambhajinagar", label: "Chhatrapati Sambhajinagar" }, // Aurangabad
    { value: "nashik", label: "Nashik" },
    { value: "thane", label: "Thane" },
    { value: "navi-mumbai", label: "Navi Mumbai" },
    { value: "kalyan-dombivli", label: "Kalyan–Dombivli" },
    { value: "vasai-virar", label: "Vasai–Virar" },
    { value: "solapur", label: "Solapur" },
    { value: "kolhapur", label: "Kolhapur" },
    { value: "satara", label: "Satara" },
    { value: "sangli", label: "Sangli" },
    { value: "jalgaon", label: "Jalgaon" },
    { value: "akola", label: "Akola" },
    { value: "amravati", label: "Amravati" },
    { value: "ahmednagar", label: "Ahmednagar" },
    { value: "latur", label: "Latur" },
    { value: "nanded", label: "Nanded" },
    { value: "parbhani", label: "Parbhani" }
  ],

  "manipur": [
    { value: "imphal", label: "Imphal" },
    { value: "thoubal", label: "Thoubal" },
    { value: "bishnupur", label: "Bishnupur" },
    { value: "churachandpur", label: "Churachandpur" },
    { value: "kakching", label: "Kakching" },
    { value: "kangpokpi", label: "Kangpokpi" },
    { value: "noney", label: "Noney" },
    { value: "pherzawl", label: "Pherzawl" },
    { value: "senapati", label: "Senapati" },
    { value: "tamenglong", label: "Tamenglong" },
    { value: "tengnoupal", label: "Tengnoupal" },
    { value: "ukhrul", label: "Ukhrul" },
    { value: "imphal-east", label: "Imphal East" },
    { value: "imphal-west", label: "Imphal West" }
  ],
  "meghalaya": [
    { value: "shillong", label: "Shillong" },
    { value: "tura", label: "Tura" },
    { value: "jowai", label: "Jowai" },
    { value: "nongsngniang", label: "Nongsngniang" },
    { value: "nongpoh", label: "Nongpoh" },
    { value: "williamnagar", label: "Williamnagar" },
    { value: "baghmara", label: "Baghmara" }
  ],
  "mizoram": [
    { value: "aizawl", label: "Aizawl" },
    { value: "lunglei", label: "Lunglei" },
    { value: "saiha", label: "Saiha" },
    { value: "champhai", label: "Champhai" },
    { value: "kolasib", label: "Kolasib" },
    { value: "serchhip", label: "Serchhip" }
  ],
  "nagaland": [
    { value: "kohima", label: "Kohima" },
    { value: "dimapur", label: "Dimapur" },
    { value: "mokokchung", label: "Mokokchung" },
    { value: "wokha", label: "Wokha" },
    { value: "tuensang", label: "Tuensang" },
    { value: "zunheboto", label: "Zunheboto" },
    { value: "mon", label: "Mon" },
    { value: "phek", label: "Phek" }
  ],
  "odisha": [
    { value: "bhubaneswar", label: "Bhubaneswar" },
    { value: "cuttack", label: "Cuttack" },
    { value: "rourkela", label: "Rourkela" },
    { value: "berhampur", label: "Berhampur" },
    { value: "sambalpur", label: "Sambalpur" },
    { value: "balasore", label: "Balasore" },
    { value: "baripada", label: "Baripada" },
    { value: "jeypore", label: "Jeypore" },
    { value: "angul", label: "Angul" }
  ],
  "punjab": [
    { value: "chandigarh", label: "Chandigarh" },
    { value: "ludhiana", label: "Ludhiana" },
    { value: "amritsar", label: "Amritsar" },
    { value: "jalandhar", label: "Jalandhar" },
    { value: "patiala", label: "Patiala" },
    { value: "bathinda", label: "Bathinda" },
    { value: "mohali", label: "Mohali" },
    { value: "hoshiarpur", label: "Hoshiarpur" },
    { value: "pathankot", label: "Pathankot" },
    { value: "moga", label: "Moga" },
    { value: "firozpur", label: "Firozpur" }
  ],
  "rajasthan": [
    { value: "jaipur", label: "Jaipur" },
    { value: "jodhpur", label: "Jodhpur" },
    { value: "udaipur", label: "Udaipur" },
    { value: "kota", label: "Kota" },
    { value: "ajmer", label: "Ajmer" },
    { value: "bikaner", label: "Bikaner" },
    { value: "alwar", label: "Alwar" },
    { value: "bharatpur", label: "Bharatpur" },
    { value: "sikar", label: "Sikar" },
    { value: "pali", label: "Pali" }
  ],
  "sikkim": [
    { value: "gangtok", label: "Gangtok" },
    { value: "namchi", label: "Namchi" },
    { value: "mangan", label: "Mangan" },
    { value: "gyalsing", label: "Gyalshing" },
    { value: "rangpo", label: "Rangpo" }
  ],
  "tamil-nadu": [
    { value: "chennai", label: "Chennai" },
    { value: "coimbatore", label: "Coimbatore" },
    { value: "madurai", label: "Madurai" },
    { value: "tiruchirappalli", label: "Tiruchirappalli" },
    { value: "salem", label: "Salem" },
    { value: "erode", label: "Erode" },
    { value: "tiruppur", label: "Tiruppur" },
    { value: "vellore", label: "Vellore" },
    { value: "thoothukudi", label: "Thoothukudi" },
    { value: "thanjavur", label: "Thanjavur" }
  ],
  "telangana": [
    { value: "hyderabad", label: "Hyderabad" },
    { value: "warangal", label: "Warangal" },
    { value: "nizamabad", label: "Nizamabad" },
    { value: "karimnagar", label: "Karimnagar" },
    { value: "khammam", label: "Khammam" },
    { value: "ramagundam", label: "Ramagundam" },
    { value: "mahbubnagar", label: "Mahbubnagar" }
  ],
  "tripura": [
    { value: "agartala", label: "Agartala" },
    { value: "udaypur", label: "Udaipur" },
    { value: "dharmanagar", label: "Dharmanagar" },
    { value: "kailashahar", label: "Kailashahar" },
    { value: "belonia", label: "Belonia" }
  ],
  "uttar-pradesh": [
    { value: "lucknow", label: "Lucknow" },
    { value: "kanpur", label: "Kanpur" },
    { value: "agra", label: "Agra" },
    { value: "varanasi", label: "Varanasi" },
    { value: "prayagraj", label: "Prayagraj" },
    { value: "meerut", label: "Meerut" },
    { value: "ghaziabad", label: "Ghaziabad" },
    { value: "noida", label: "Noida" },
    { value: "aligarh", label: "Aligarh" },
    { value: "moradabad", label: "Moradabad" }
  ],
  "uttarakhand": [
    { value: "dehradun", label: "Dehradun" },
    { value: "haridwar", label: "Haridwar" },
    { value: "nainital", label: "Nainital" },
    { value: "haldwani", label: "Haldwani" },
    { value: "rudrapur", label: "Rudrapur" },
    { value: "roorkee", label: "Roorkee" },
    { value: "almora", label: "Almora" }
  ],
  "west-bengal": [
    { value: "kolkata", label: "Kolkata" },
    { value: "howrah", label: "Howrah" },
    { value: "durgapur", label: "Durgapur" },
    { value: "asansol", label: "Asansol" },
    { value: "siliguri", label: "Siliguri" },
    { value: "malda", label: "Malda" },
    { value: "kharagpur", label: "Kharagpur" },
    { value: "bardhaman", label: "Bardhaman" },
    { value: "haldia", label: "Haldia" }
  ],
  "goa": [
    { value: "panaji", label: "Panaji" },
    { value: "margao", label: "Margao" },
    { value: "vasco-da-gama", label: "Vasco da Gama" },
    { value: "mapusa", label: "Mapusa" },
    { value: "ponda", label: "Ponda" },
    { value: "bicholim", label: "Bicholim" },
    { value: "curchorem", label: "Curchorem" },
    { value: "cuncolim", label: "Cuncolim" },
    { value: "sanquelim", label: "Sanquelim" },
    { value: "valpoi", label: "Valpoi" },
    { value: "canacona", label: "Canacona" },
    { value: "pernem", label: "Pernem" }
  ],

};

export const indianStates = [
  { value: "andhra-pradesh", label: "Andhra Pradesh" },
  { value: "arunachal-pradesh", label: "Arunachal Pradesh" },
  { value: "assam", label: "Assam" },
  { value: "bihar", label: "Bihar" },
  { value: "chhattisgarh", label: "Chhattisgarh" },
  { value: "goa", label: "Goa" },
  { value: "gujarat", label: "Gujarat" },
  { value: "haryana", label: "Haryana" },
  { value: "himachal-pradesh", label: "Himachal Pradesh" },
  { value: "jammu-kashmir", label: "Jammu-kashmir" },
  { value: "jharkhand", label: "Jharkhand" },
  { value: "karnataka", label: "Karnataka" },
  { value: "kerala", label: "Kerala" },
  { value: "ladakh", label: "Ladakh" },
  { value: "madhya-pradesh", label: "Madhya Pradesh" },
  { value: "maharashtra", label: "Maharashtra" },
  { value: "manipur", label: "Manipur" },
  { value: "meghalaya", label: "Meghalaya" },
  { value: "mizoram", label: "Mizoram" },
  { value: "nagaland", label: "Nagaland" },
  { value: "odisha", label: "Odisha" },
  { value: "punjab", label: "Punjab" },
  { value: "rajasthan", label: "Rajasthan" },
  { value: "sikkim", label: "Sikkim" },
  { value: "tamil-nadu", label: "Tamil Nadu" },
  { value: "telangana", label: "Telangana" },
  { value: "tripura", label: "Tripura" },
  { value: "uttar-pradesh", label: "Uttar Pradesh" },
  { value: "uttarakhand", label: "Uttarakhand" },
  { value: "west-bengal", label: "West Bengal" }
];

export const countries = [
  { value: "in", label: "India" },
];

